// extracted by mini-css-extract-plugin
export default {"modalWrapper":"RejectReason_modalWrapper__Jfcnr"};